export default __webpack_public_path__ + "static/media/roleSelect.11368f01.png";